import React__default from 'react';
import styled, { css } from 'styled-components';
import { S as STATUS } from './constants-d5DDIlHP.js';
import { I as Icon } from '../Icon/Icon-AcXbY_t4.js';
import { c as check } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';

const StepsWrapper = /*#__PURE__*/styled('ol').withConfig({
  componentId: "sc-storm-ui-40027066__sc-8m8xz5-0"
})(["display:flex;margin:0;", ""], ({
  $isVertical
}) => $isVertical && css(["flex-direction:column;width:fit-content;"]));
const Steps = ({
  icons = {
    completed: /*#__PURE__*/React__default.createElement(Icon, {
      type: check
    })
  },
  numbered = true,
  children,
  initial = 0,
  current = 0,
  inlineLabel = true,
  description = 'Steps',
  statusDescriptions = {},
  isVertical = false
}) => {
  const mergedStatusDescription = {
    ...{
      completed: 'Completed step',
      active: 'Active step',
      future: 'Future step',
      disabled: 'Unavailable step'
    },
    ...statusDescriptions
  };
  const childArray = React__default.Children.toArray(children);
  const numChildren = childArray.length;
  return /*#__PURE__*/React__default.createElement(StepsWrapper, {
    role: "list",
    "aria-label": description,
    $isVertical: isVertical
  }, childArray.map((child, index) => {
    var _child$props$stepNumb;
    if (! /*#__PURE__*/React__default.isValidElement(child)) {
      return null;
    }
    const stepIndex = initial + index;
    const childProps = {
      ...child.props,
      isFirstStep: index === 0,
      isLastStep: index === numChildren - 1,
      stepNumber: (_child$props$stepNumb = child.props.stepNumber) !== null && _child$props$stepNumb !== void 0 ? _child$props$stepNumb : `${stepIndex + 1}`,
      icons,
      isVertical,
      numbered,
      inlineLabel,
      statusDescriptions: mergedStatusDescription
    };
    if (!child.props.status) {
      if (stepIndex === current) {
        childProps.status = STATUS.ACTIVE;
      } else if (stepIndex < current) {
        childProps.status = STATUS.COMPLETED;
      } else {
        childProps.status = STATUS.FUTURE;
      }
    }
    return /*#__PURE__*/React__default.cloneElement(child, childProps);
  }));
};

export { Steps as S };
//# sourceMappingURL=Steps-Tj6BGGvr.js.map
